import React, { useEffect, useState } from "react";
import api from "../lib/api";
import ExperienceCard from "../components/ExperienceCard";
import { Button } from "../components/ui/button";
import { Hotel, Wine, Sparkles } from "lucide-react";
import { useLang } from "../contexts/LangContext";

export default function Esperienze() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [filter, setFilter] = useState("all"); // all | cantina_visit | resort
  useEffect(() => {
    api.get("/experiences").then(r => setItems(r.data));
    api.get("/featured/experiences?limit=3").then(r => setFeatured(r.data)).catch(() => {});
  }, []);
  const filtered = filter === "all" ? items : items.filter(e => e.type === filter);
  const featuredList = featured.length ? featured : items.slice(0, 3);
  return (
    <div data-testid="esperienze-page">
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/static/heroes/esperienze_hero.png`} alt="" className="absolute inset-0 w-full h-full object-cover animate-ken-burns" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/30 to-black/20" />
        <div className="relative container-xl h-full flex flex-col justify-end pb-12">
          <div className="text-xs uppercase tracking-[0.4em] text-[#E2A03F] mb-3">{t("page.experiences.eyebrow")}</div>
          <h1 className="editorial-heading text-4xl sm:text-5xl md:text-7xl text-white leading-tight md:leading-[0.95]">{t("page.experiences.title")}</h1>
          <p className="text-white/80 text-base md:text-lg mt-3 max-w-2xl">{t("page.experiences.subtitle")}</p>
        </div>
      </section>

      {/* FEATURED STRIP */}
      {featuredList.length > 0 && (
        <section data-testid="esperienze-featured" className="container-xl pt-12 md:pt-16">
          <div className="bg-gradient-to-br from-[hsl(var(--primary))]/5 to-transparent border border-[hsl(var(--primary))]/15 rounded-sm p-5 md:p-8">
            <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2 flex items-center gap-2">
              <Sparkles className="h-3.5 w-3.5" /> Esperienze più richieste · prenotabili ora
            </div>
            <div className="text-sm text-muted-foreground mb-5">Le 3 esperienze più amate dai nostri ospiti — disponibili da subito.</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {featuredList.map(e => <ExperienceCard key={e.id} exp={e} />)}
            </div>
          </div>
        </section>
      )}

      <section className="container-xl py-12">
        <div className="flex flex-wrap gap-2 mb-10">
          <Button data-testid="exp-filter-all" variant={filter === "all" ? "default" : "outline"} onClick={() => setFilter("all")} size="sm" className={`rounded-full ${filter === "all" ? "bg-[hsl(var(--primary))] text-white" : ""}`}>Tutte ({items.length})</Button>
          <Button data-testid="exp-filter-cantina" variant={filter === "cantina_visit" ? "default" : "outline"} onClick={() => setFilter("cantina_visit")} size="sm" className={`rounded-full gap-2 ${filter === "cantina_visit" ? "bg-[hsl(var(--primary))] text-white" : ""}`}><Wine className="h-3.5 w-3.5" />Visite in cantina</Button>
          <Button data-testid="exp-filter-resort" variant={filter === "resort" ? "default" : "outline"} onClick={() => setFilter("resort")} size="sm" className={`rounded-full gap-2 ${filter === "resort" ? "bg-[hsl(var(--primary))] text-white" : ""}`}><Hotel className="h-3.5 w-3.5" />Wine Resort</Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(e => <ExperienceCard key={e.id} exp={e} />)}
        </div>
      </section>
    </div>
  );
}
